import { Knobs, Knob } from '../../Docs/DocTypes';
import { camelCaseToDash } from '../../Docs/DocsUtils';

export type KnobValues = { [key: string]: any };

export const getWindowWidth = () => window.innerWidth;

export function parseCodeWithKnobs(
  code: string,
  knobs: Knobs = {},
  knobValues: KnobValues = [],
  camelCaseAttributes: boolean,
) {
  const codeWithParsedAttributes = parseAttributeTokens(
    code,
    knobs,
    knobValues,
    camelCaseAttributes,
  );
  const codeWithParsedRestToken = parseRestToken(
    codeWithParsedAttributes,
    knobs,
    knobValues,
    camelCaseAttributes,
  );
  return codeWithParsedRestToken;
}

export function parseAttributeTokens(
  code: string,
  knobs: Knobs,
  knobValues: KnobValues,
  camelCaseAttributes: boolean,
) {
  const knobAttributeStartToken = '{{';
  const knobAttributeEndToken = '}}';

  let newCode = code;
  let first = true;
  Object.keys(knobs).forEach(key => {
    const attr = buildAttributeFromKnob(key, knobs[key], knobValues[key], camelCaseAttributes);
    if (attr) {
      const delim = knobs[key].delimiter ? knobs[key].delimiter : first ? '' : ' ';
      newCode = newCode.replace(
        new RegExp(`${knobAttributeStartToken}${key}${knobAttributeEndToken}`, 'g'),
        `${delim}${attr}`,
      );
      first = false;
    } else {
      newCode = newCode.replace(
        new RegExp(`${knobAttributeStartToken}${key}${knobAttributeEndToken}`, 'g'),
        '',
      );
    }
  });
  return newCode;
}

function buildAttributeFromKnob(
  name: string,
  knob: Knob,
  knobValue: any,
  camelCaseAttributes: boolean,
) {
  const attrName = knob.attribute
    ? knob.attribute
    : camelCaseAttributes
    ? camelCaseToDash(name)
    : name;
  const attrQualStart = knob.qualifierStart ? knob.qualifierStart : "'";
  const attrQualEnd = knob.qualifierEnd ? knob.qualifierEnd : "'";
  let attr = '';
  if (typeof knobValue === 'boolean') {
    attr = knobValue === true ? `${attrName}` : '';
  } else {
    attr =
      knobValue !== undefined && knobValue !== null && knobValue !== ''
        ? `${attrName}=${attrQualStart}${knobValue}${attrQualEnd}`
        : '';
  }
  return attr;
}

export function parseRestToken(
  code: string,
  knobs: Knobs,
  knobValues: KnobValues,
  camelCaseAttributes: boolean,
) {
  const token = '{{...knobs}}';
  let attrs = '';
  Object.keys(knobs).forEach(key => {
    const attr = buildAttributeFromKnob(key, knobs[key], knobValues[key], camelCaseAttributes);
    if (attr) {
      const delimChar = knobs[key].delimiter
        ? knobs[key].delimiter
        : knobValuesCount(knobValues) > 2
        ? '\n  '
        : ' ';
      attrs = `${attrs}${delimChar}${attr}`;
    }
  });
  let newCode = code.replace(token, attrs);
  return newCode;
}

function knobValuesCount(knobValues: KnobValues) {
  let sum = 0;
  Object.keys(knobValues).forEach(key => {
    if (
      knobValues[key] !== undefined &&
      knobValues[key] !== null &&
      knobValues[key] !== '' &&
      knobValues[key] !== false
    ) {
      sum = sum + 1;
    }
  });
  return sum;
}

export function getKnobValues(knobs: Knobs = {}, initialValues: KnobValues = []) {
  let build: KnobValues = {};
  Object.keys(knobs).forEach(key => {
    if (initialValues[key] !== undefined) {
      build[key] = initialValues[key];
    } else {
      build[key] = knobs[key].default;
    }
  });
  return build;
}
